import { Injectable } from '@angular/core';
import {
  type IContextualAction,
  type IRoutable,
  StateBasedNavigationService,
} from '@principle-theorem/ng-principle-shared';
import { isPrincipleMention } from '@principle-theorem/principle-core/interfaces';
import { type IReffable } from '@principle-theorem/shared';

@Injectable({
  providedIn: 'root',
})
export class LoadContactActionService implements IContextualAction {
  icon = 'open_in_new';
  name = 'View Contact';

  constructor(private _stateNav: StateBasedNavigationService) {}

  async do(contact: IRoutable | IReffable): Promise<void> {
    if (isPrincipleMention(contact)) {
      contact = contact.resource;
    }
    const uid: string = 'uid' in contact ? contact.uid : contact.ref.id;
    await this._stateNav.practice(['contacts', uid]);
  }
}
